// vim: set ts=2 sts=2 sw=2 :
//
import MmenuLight from 'mmenu-light';
import 'stylesheets/navigation.scss';

document.addEventListener('DOMContentLoaded', function () {
  const targetElement = document.querySelector('#mmenu-menu');

  // レスポンシブではないので、PCビューのときは要素がない
  if (!targetElement) return true;

  const menu = new MmenuLight(targetElement);
  const drawer = menu.offcanvas();

  document.querySelector('a[href="#mmenu-menu"]').addEventListener('click', function (evt) {
    evt.preventDefault();
    drawer.open();
  });
});
